import * as Yup from 'yup';

/** Mirrors Password::defaults() on the server (AppServiceProvider). */
export const PASSWORD_HINT = 'At least 8 characters, with upper and lower case letters, a number and a symbol.';

export const newPasswordSchema = Yup.string()
  .required('Choose a password.')
  .min(8, PASSWORD_HINT)
  .matches(/[a-z]/, PASSWORD_HINT)
  .matches(/[A-Z]/, PASSWORD_HINT)
  .matches(/\d/, PASSWORD_HINT)
  .matches(/[^A-Za-z0-9]/, PASSWORD_HINT);

export const confirmPasswordSchema = Yup.string()
  .required('Type the password again.')
  .oneOf([Yup.ref('password')], 'The passwords do not match.');
